import { 
	DEACTIVATE_ROL, ACTIVATE_ROL, CREATE_ROL, UPDATE_ROL, GET_ERRORS, GET_ROLES 
} from "../actions/types";

const initialState = {
	actionType: '',
	roles:      [],
	error:      {},
};

export default function (state = initialState, action) {
	switch (action.type) {
		case CREATE_ROL:
			return {
				...state,
				actionType: action.type,
				success:    'El rol fue creado exitosamente.'
			};
		case UPDATE_ROL:
			return {
				...state,
				actionType: action.type,
				success:    'El rol fue actualizado exitosamente.'
			};
		case GET_ROLES:
			return {
				...state,
				actionType: action.type,
				roles:      action.payload.message,
				success:    'Se obtuvieron ' + action.payload.message.length + " roles."
			};
		case DEACTIVATE_ROL:
			return {
				...state,
				actionType: action.type,
				success:    'El rol fue desactivado exitosamente.'
			};
    case ACTIVATE_ROL:
      return {
        ...state,
        actionType: action.type,
        success:    'El rol fue activado exitosamente.'
      };
		case GET_ERRORS:
			return {
				...state,
				actionType: action.type,
				message:    action.payload
			};
		default:
			return state;
	}
}